module.exports = __webpack_public_path__ + "static/media/Filter.f9bb5f53.svg";